import { createFileRoute } from '@tanstack/react-router';
import { JourneysPersonSentRoute } from './-route-wrappers';

/**
 * `/journeys/people/:personId/sent` — the address the embedded app's profile tab bar links
 * to. It forwards to the tab's own URL once the rollout flag is on, and renders the embedded app
 * in place while it is off.
 */
function JourneysPersonSentIndexRoute() {
  const { personId } = Route.useParams();

  return <JourneysPersonSentRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/people/$personId/sent/')({
  component: JourneysPersonSentIndexRoute,
});
